import { Component } from 'vue-property-decorator'
import dayjs from 'dayjs'
import renderUtils from '@/components/RenderUtils'
import MergeHooks from '@/decorators/mergeHooks'
import { tranformOptionsShape } from '@/components/RenderUtils/utils/index'
import { MasterlinkTenantServiceProxy,TenantGatewayServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { FirmwareServiceProxy } from '@/service-proxies/app-v2/console.service-proxies'
import {
  FirmwareServiceProxy as FirmwareService,
  GatewayServiceProxy,
  PageGatewayDTO
} from '@/service-proxies/app-v2/iot-console.service-proxies'

const mtsp = new MasterlinkTenantServiceProxy()
const tgsp = new TenantGatewayServiceProxy()
const fsp = new FirmwareServiceProxy()
const fs = new FirmwareService()
const gsp = new GatewayServiceProxy()

@Component
@MergeHooks
export default class LogManagement extends renderUtils {
  tenantOpts = []
  gateways = []
  topData = []
  bottomData = []
  selectRow = ''

  filters = {
    tenantId: undefined,
    gatewayCode: 'all',
    firmwareName: undefined
  }

  pagination = {
    total: 0,
    pageSize: 10,
    current: 1
  }

  get version() {
    if (~this.$route.path.indexOf('edge-data')) {
      return 'old'
    } else if (~this.$route.path.indexOf('iot-console')) {
      return 'new'
    }
  }

  get topColumns() {
    return [
      {
        title: this.$t('page_tenant'),
        width: 200,
        dataIndex: 'tenantId',
        customRender: (id) => {
          const find = this.tenantOpts.find((item) => item.value == id)
          return (find && find.label) || id || ''
        }
      },
      {
        title: this.$t('page_log_management_sn'),
        width: 200,
        dataIndex: 'gatewayCode'
      },
      {
        title: this.$t('page_firmware_management_name'),
        width: 200,
        dataIndex: 'fileName'
      },
      {
        title: this.$t('page_resource_pool_status'),
        width: 200,
        dataIndex: 'state',
        customRender: (status) => {
          if (this.version === 'old') {
            return (
              <div>
                <a-badge
                  color={
                    Number(status) !== 2
                      ? Number(status) === 1
                      ? 'green'
                      : 'red'
                      : 'yellow'
                  }
                  text={
                    Number(status) !== 2
                      ? Number(status) === 1
                      ? this.$t('page_log_management_success')
                      : this.$t('page_log_management_fail')
                      : this.$t('page_log_management_process')
                  }
                />
              </div>
            )
          } else {
            let map = {
              0: { color: 'green', text: 'page_log_management_success' },
              1: { color: 'yellow', text: 'page_log_management_process' },
              2: { color: 'red', text: 'page_log_management_fail' },
              3: { color: 'red', text: 'page_log_management_fail' }
            }

            return (
              <div>
                <a-badge
                  color={
                    map[Number(status)].color
                  }
                  text={
                    this.$t(map[Number(status)].text)
                  }
                />
              </div>
            )
          }
        }
      },
      {
        title: this.$t('page_log_management_time'),
        dataIndex: 'createTime',
        customRender: (text) => {
          return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    ]
  }

  get bottomColumns() {
    return [
      {
        title: this.$t('page_log_management_action'),
        width: 300,
        dataIndex: 'action',
        customRender: (status) => {
          if (status == 2) {
            return this.$t('page_log_management_action_2')
          } else if (status == 3) {
            return this.$t('page_log_management_action_3')
          } else if (status == 4) {
            return this.$t('page_log_management_action_4')
          } else if (status == 0 || status == 1) {
            return this.$t('page_log_management_action_0')
          } else {
            return ''
          }
        }
      },
      {
        title: this.$t('page_log_management_status'),
        width: 300,
        dataIndex: this.version === 'old' ? 'state' : 'actionEnd',
        customRender: (status) => {
          // if (this.version === 'old') {
          return (<div>
              <a-badge
                color={Number(status) ? 'red' : 'green'}
                text={
                  Number(status)
                    ? this.$t('page_log_management_fail')
                    : this.$t('page_log_management_success')
                }
              />
            </div>
          )
          /*} else {
            let map = {
              0: { color: 'green', text: 'page_log_management_status_0' },
              1: { color: 'processing', text: 'page_log_management_status_1' },
              2: { color: 'red', text: 'page_terminal_download_fail' },
              3: { color: 'red', text: 'page_log_management_status_3' },
              4: { color: 'red', text: 'page_log_management_status_4' }
            }
            return (<div>
                <a-badge
                  color={map[Number(status)].color}
                  text={this.$t(map[Number(status)].text)}
                />
              </div>
            )
          }*/
        }
      },
      {
        title: this.$t('page_log_management_time'),
        dataIndex: 'createTime',
        customRender: (text) => {
          return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    ]
  }

  async mounted() {
    /*
    const { data } = await mtsp.getTenants(
      undefined,
      1,
      -1,
      undefined,
      undefined
    )
    const opts = tranformOptionsShape('tenantCode', 'tenantId')(data.records)
    this.tenantOpts = opts
    if (opts.length) {
      this.filters.tenantId = opts[0].value
      this.changeTenant(opts[0].value)
      // this.onSearch();
    }
    */
  }

  async changeTenant(val) {

    let gateways
    if (this.version === 'old') {
      gateways = await tgsp.getGateways('', val)
    } else {
      const param = {
        ascs: '',
        batchCode: '',
        current: 1,
        descs: '',
        filter: '',
        isOnline: undefined,
        size: -1,
        tenantId: ''
      } as PageGatewayDTO
      const { items } = await gsp.findGatewayList(param)
      gateways = items
    }

    const opts = tranformOptionsShape('code', 'code')(gateways)
    opts.unshift({
      label: this.$t('page_log_management_all_gateways'),
      value: 'all'
    })
    this.gateways = opts
    this.filters.gatewayCode = 'all'
    this.$nextTick(() => this.onSearch())
  }

  render() {
    return (
      <blank-view bodyStyle={{ overflow: 'hidden' }}>
        <div slot="action" style="display:flex;justify-content: flex-end">

        <tenant-select
            style="width:200px;margin-right: 3px;margin-left: 5px"
            ref="tenantSelect"
            multiple={false}
            v-model={this.filters.tenantId}
            onChange={this.changeTenant}
        ></tenant-select>
        
          
          <a-select
            showSearch={true}
            optionFilterProp="children"
            style="margin:0 10px;width: 200px"
            options={this.gateways}
            v-model={this.filters.gatewayCode}
            onChange={this.onSearch}
          ></a-select>
          <a-input-search
            placeholder={this.$t('keyword')}
            enter-button={this.$t('search')}
            style="width: 250px"
            v-model={this.filters.firmwareName}
            onSearch={this.onSearch}
            allowClear
          />
        </div>
        <div
          style={{
            // display: "flex",
            // flexDirection: "column",
            background: '#f0f2f5',
            height: '100%'
          }}
        >
          {this.renderTopTable()}
          <div v-resize={'y'}></div>
          {this.renderBottomTable()}
        </div>
      </blank-view>
    )
  }

  renderTopTable() {
    return (
      <div
        style={{
          background: '#fff',
          marginBottom: '10px',
          overflow: 'hidden',
          height: '60%'
        }}
      >
        <div style={{ height: 'calc(100% - 60px)', 'overflow-y': 'auto' }}>
          <ml-table
            size="small"
            rowKey="issueId"
            selectRowKey={this.selectRow}
            columns={this.topColumns}
            dataSource={this.topData}
            canChangeColWidth={true}
            customRow={(row) => ({
              on: {
                click: () => this.changeBottomTable(row)
              }
            })}
          ></ml-table>
        </div>
        <a-pagination
          style="float:right;margin-top:20px"
          {...{ props: this.pagination }}
          onChange={this.pageIndexchange}
        ></a-pagination>
      </div>
    )
  }

  renderBottomTable() {
    return (
      <div style={{ background: '#fff', height: '40%' }}>
        <ml-table
          size="small"
          rowKey="issueId"
          columns={this.bottomColumns}
          dataSource={this.bottomData}
          canChangeColWidth={true}
        ></ml-table>
      </div>
    )
  }

  pageIndexchange(current, pageSize) {
    this.pagination.pageSize = pageSize
    this.pagination.current = current
    this.onSearch()
  }

  async onSearch() {
    this.selectRow = ''
    this.bottomData = []
    if (this.version === 'old') {
      const data = {
        tenantId: this.filters.tenantId === 'all' ? '' : this.filters.tenantId,
        gatewayCode:
          this.filters.gatewayCode === 'all' ? '' : this.filters.gatewayCode,
        firmwareName: this.filters.firmwareName,
        query: {
          current: this.pagination.current,
          size: this.pagination.pageSize
        }
      }

      const result = await fsp.getPageFirmwareLogs(data as any)
      this.pagination.total = Number(result.total)
      this.topData = result.items
    } else {
      let params = {
        ascs: '',
        current: this.pagination.current,
        descs: undefined,
        filter: undefined,
        /** 固件名称 */
        firmwareName: this.filters.firmwareName,
        gatewayCode: this.filters.gatewayCode === 'all' ? '' : this.filters.gatewayCode,
        size: this.pagination.pageSize,
        tenantId: this.filters.tenantId === 'all' ? '' : this.filters.tenantId
      }
      const { totalCount, items } = await fs.pageFirmwareLog(params as any)
      this.pagination.total = Number(totalCount)
      this.topData = items
    }
  }

  async changeBottomTable(row) {
    this.selectRow = row.issueId
    const { issueId } = row
    if (this.version === 'old') {
      this.bottomData = await fsp.getFirmwareLogs(issueId)
    } else {
      this.bottomData = await fs.getFirmwareLog(issueId)
    }

  }
}
